<template>
    <div class="v2-tab-content">
        <div class="page-section">
            <a-card :bordered="false" style="width: 100%">
                <template slot="title">
                    <div class="v2-tab-hd">
                        <h2>{{ approved ? "Requisição aprovada" : "Requisição rejeitada" }}</h2>
                    </div>
                </template>
                <template slot="extra">
                    <a-tag :color="approved ? 'green' : 'red'">{{ approved ? "Aprovada" : "Rejeitada" }}</a-tag>
                </template>

                <a-alert v-if="!approved" type="error" show-icon class="decision-alert">
                    <span slot="message">Motivo da rejeição</span>
                    <span slot="description" class="reason">{{ order.rejection_reason || "--" }}</span>
                </a-alert>

                <a-row :gutter="[16, 16]">
                    <a-col :xs="24" :sm="12" :lg="6">
                        <div class="info-label">{{ approved ? "Aprovada em" : "Rejeitada em" }}</div>
                        <div class="info-value">{{ formatDateTime(order.decided_at) }}</div>
                    </a-col>
                    <a-col :xs="24" :sm="12" :lg="6">
                        <div class="info-label">{{ approved ? "Aprovada por" : "Rejeitada por" }}</div>
                        <div class="info-value">{{ order.decided_by ? order.decided_by.name : "--" }}</div>
                    </a-col>
                    <a-col v-if="order.resupply_id" :xs="24" :sm="12" :lg="6">
                        <div class="info-label">Ressuprimento dos produtos em falta</div>
                        <div class="info-value">
                            <router-link :to="{ name: 'Ressuprimento-Editar', params: { id: order.resupply_id } }">#{{ order.resupply_id }}</router-link>
                        </div>
                    </a-col>
                </a-row>

            </a-card>
        </div>
    </div>
</template>

<script>
import visitFormat from "@/pages/visits/visit-format.mixin";

export default {
    name: "SellerOrderDecisionTab",
    mixins: [visitFormat],
    props: {
        order: { type: Object, required: true },
    },
    computed: {
        approved() {
            return this.order.status === "APPROVED";
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/pages/visits/_detail-page";

.decision-alert {
    margin-bottom: 16px;
}

.reason {
    white-space: pre-line;
}
</style>
